/* Isolated decorative enhancement. Does not read product data or own commerce. */
(() => {
  if (!document.body.classList.contains('template-product-campaign-lab')) return;
  if (window.campaignDepthDividerInitialized) return;
  window.campaignDepthDividerInitialized = true;
  const motion = window.matchMedia('(prefers-reduced-motion: no-preference)');
  const instances = new Map();

  const mount = (box) => {
    if (instances.has(box)) return;
    const art = box.querySelector('.campaign-depth-divider__art');
    if (!art) return;
    let visible = false;
    let started = false;
    let complete = false;
    let observer;
    const settle = () => {
      complete = true;
      box.removeAttribute('data-depth-animate');
      box.removeAttribute('data-depth-playing');
    };
    const sync = () => {
      const allowed = motion.matches && box.dataset.motionEnabled === 'true';
      if (started && !allowed) settle();
      const playing = allowed && visible && !document.hidden && art.complete && art.naturalWidth > 0 && !complete;
      if (playing && !started) {
        started = true;
        box.setAttribute('data-depth-animate', '');
      }
      box.toggleAttribute('data-depth-playing', playing);
    };
    const fail = () => {
      box.hidden = true;
      observer?.disconnect();
      settle();
    };
    const loaded = () => {
      if (art.naturalWidth > 0) sync();
      else fail();
    };
    const finished = (event) => { if (event.target === art) settle(); };
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        visible = entries.some(entry => entry.isIntersecting);
        sync();
      }, { threshold: .1 });
      observer.observe(box);
    }
    art.addEventListener('load', loaded);
    art.addEventListener('error', fail);
    art.addEventListener('animationend', finished);
    motion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    if (art.complete) loaded();
    else sync();
    instances.set(box, () => {
      observer?.disconnect();
      art.removeEventListener('load', loaded);
      art.removeEventListener('error', fail);
      art.removeEventListener('animationend', finished);
      motion.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
      box.removeAttribute('data-depth-animate');
      box.removeAttribute('data-depth-playing');
      instances.delete(box);
    });
  };
  const init = () => document.querySelectorAll('[data-campaign-depth-divider]').forEach(mount);
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, box) => { if (event.target.contains(box)) cleanup(); });
  });
  window.addEventListener('pagehide', () => instances.forEach(cleanup => cleanup()));
  window.addEventListener('pageshow', (event) => { if (event.persisted) init(); });
})();
